import React from 'react';
import { useAbility } from '@casl/react';
import { VerticalNav } from '@bynder/design-system';
import { IconSearch } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { useRecentSearches } from './hooks/useRecentSearches';
import { AbilityContext } from '../../abilities/Can';

type Props = {
	setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
};

export function RecentSearches({ setSearchTerm }: Props) {
	const { translate } = useTranslate();
	const ability = useAbility(AbilityContext);
	const { executeSearch, searchTerms } = useRecentSearches();
	const isStickySearchEnabled = ability.can('show', 'sticky_search');

	const handleSearch = (term: string) => {
		executeSearch(term);

		if (isStickySearchEnabled) {
			setSearchTerm(term);
		}
	};

	return (
		<div>
			<VerticalNav>
				<VerticalNav.Title>{translate('spotlightHelp.recentSearches')}</VerticalNav.Title>

				{searchTerms.map((term: string) => (
					<VerticalNav.Item
						key={term}
						as="button"
						isActive={false}
						icon={<IconSearch />}
						onClick={() => handleSearch(term)}
						data-heapId="discover_spotlight-recent-searches"
					>
						{term}
					</VerticalNav.Item>
				))}
			</VerticalNav>
		</div>
	);
}
